import React from 'react';
import './Skeletons.scss';

/** Placeholder matching the real product card's geometry. */
export const ProductCardSkeleton = () => (
  <div className="product-card skeleton-card" aria-hidden="true">
    <div className="skeleton skeleton-card__media" />
    <div className="skeleton-card__body">
      <div className="skeleton skeleton--text" style={{ width: '90%' }} />
      <div className="skeleton skeleton--text" style={{ width: '65%' }} />
      <div className="skeleton skeleton--text" style={{ width: '40%', height: '1.2em' }} />
    </div>
    <div className="skeleton-card__action">
      <div className="skeleton" style={{ height: '36px', borderRadius: 'var(--radius-md)' }} />
    </div>
  </div>
);

/**
 * A full grid of card placeholders. Keeps the page's layout stable
 * while products load instead of collapsing to a spinner.
 */
export const ProductGridSkeleton = ({ count = 8, variant = 'grid', columns }) => (
  <div
    // Matches the real grid's column count so the layout does not
    // shift when the products arrive.
    className={
      variant === 'rail'
        ? 'product-rail'
        : `product-grid${columns ? ` product-grid--${columns}up` : ''}`
    }
    aria-busy="true"
    aria-live="polite"
  >
    <span className="visually-hidden">Loading products…</span>
    {Array.from({ length: count }).map((_, index) => (
      <ProductCardSkeleton key={index} />
    ))}
  </div>
);

/** Generic stacked text lines, for prose-heavy pages. */
export const TextSkeleton = ({ lines = 5 }) => (
  <div aria-hidden="true">
    {Array.from({ length: lines }).map((_, index) => (
      <div
        key={index}
        className="skeleton skeleton--text"
        style={{ width: `${index === lines - 1 ? 55 : 88 + (index % 3) * 4}%` }}
      />
    ))}
  </div>
);

export default ProductGridSkeleton;
